import React from 'react'
import { eventTracking } from '../../utils/tracking'


function RighArrow(props) {
  const {style, onClick, object_name, custom_tag} = props
  return (
    <div className="arrow-container right-arrow-container"
      style={{...style}}
      onClick={ () => {
        eventTracking(object_name, "click_right_arrow", "recommendation", { custom_tag })
        onClick()
      }}
    >
      <svg className="icon arrow" name="chevronRight" color="white" viewBox="0 0 24 24" width="20px" height="46px" data-reactid="27"><path d="M8.46966991,17.4696699 C8.1767767,17.7625631 8.1767767,18.2374369 8.46966991,18.5303301 C8.76256313,18.8232233 9.23743687,18.8232233 9.53033009,18.5303301 L15.5303301,12.5303301 C15.8232233,12.2374369 15.8232233,11.7625631 15.5303301,11.4696699 L9.53033009,5.46966991 C9.23743687,5.1767767 8.76256313,5.1767767 8.46966991,5.46966991 C8.1767767,5.76256313 8.1767767,6.23743687 8.46966991,6.53033009 L13.9393398,12 L8.46966991,17.4696699 Z" data-reactid="28"></path></svg>
    </div>
  );
}

function LeftArrow(props) {
  const {style, onClick, object_name, custom_tag} = props
  return (
    <div className="arrow-container left-arrow-container"
      style={{...style}}
      onClick={ () => {
        eventTracking(object_name, "click_left_arrow", "recommendation", { custom_tag })
        onClick()
      }}
    >
      <svg className="icon arrow" name="chevronLeft" color="white" viewBox="0 0 24 24" width="20px" height="46px" data-reactid="24"><path d="M15.5303301,6.53033009 C15.8232233,6.23743687 15.8232233,5.76256313 15.5303301,5.46966991 C15.2374369,5.1767767 14.7625631,5.1767767 14.4696699,5.46966991 L8.46966991,11.4696699 C8.1767767,11.7625631 8.1767767,12.2374369 8.46966991,12.5303301 L14.4696699,18.5303301 C14.7625631,18.8232233 15.2374369,18.8232233 15.5303301,18.5303301 C15.8232233,18.2374369 15.8232233,17.7625631 15.5303301,17.4696699 L10.0606602,12 L15.5303301,6.53033009 Z" data-reactid="25"></path></svg>
    </div>
  );
}

function BottomArrow(props) {
  const {style, onClick, object_name, custom_tag} = props
  return (
    <div className="arrow-container arrow-container-vertical"
      style={{...style}}
      onClick={ () => {
        eventTracking(object_name, "click_bottom_arrow", "recommendation", { custom_tag })
        onClick()
      }}
    >
      <svg className="icon arrow arrow-vertical" name="chevronRight" color="white" viewBox="0 0 24 24" width="20px" height="46px" data-reactid="27"><path d="M8.46966991,17.4696699 C8.1767767,17.7625631 8.1767767,18.2374369 8.46966991,18.5303301 C8.76256313,18.8232233 9.23743687,18.8232233 9.53033009,18.5303301 L15.5303301,12.5303301 C15.8232233,12.2374369 15.8232233,11.7625631 15.5303301,11.4696699 L9.53033009,5.46966991 C9.23743687,5.1767767 8.76256313,5.1767767 8.46966991,5.46966991 C8.1767767,5.76256313 8.1767767,6.23743687 8.46966991,6.53033009 L13.9393398,12 L8.46966991,17.4696699 Z" data-reactid="28"></path></svg>
    </div>
  );
}

function TopArrow(props) {
  const {style, onClick, object_name, custom_tag} = props
  return (
    <div className="arrow-container arrow-container-vertical"
      style={{...style}}
      onClick={ () => {
        eventTracking(object_name, "click_top_arrow", "recommendation", { custom_tag })
        onClick()
      }}
    >
      <svg className="icon arrow arrow-vertical" name="chevronLeft" color="white" viewBox="0 0 24 24" width="20px" height="46px" data-reactid="24"><path d="M15.5303301,6.53033009 C15.8232233,6.23743687 15.8232233,5.76256313 15.5303301,5.46966991 C15.2374369,5.1767767 14.7625631,5.1767767 14.4696699,5.46966991 L8.46966991,11.4696699 C8.1767767,11.7625631 8.1767767,12.2374369 8.46966991,12.5303301 L14.4696699,18.5303301 C14.7625631,18.8232233 15.2374369,18.8232233 15.5303301,18.5303301 C15.8232233,18.2374369 15.8232233,17.7625631 15.5303301,17.4696699 L10.0606602,12 L15.5303301,6.53033009 Z" data-reactid="25"></path></svg>
    </div>
  );
}

export { LeftArrow, RighArrow, TopArrow, BottomArrow }



// WEBPACK FOOTER //
// ./src/node_modules/components/Pimper/WebCarousel/components/Arrows.js